import React from 'react'
import { LocalAudioTrack, RemoteAudioTrack } from 'twilio-video'

import { css } from 'design'
import { cn } from 'util/cn'

import { useAudioIndicator } from './use_audio_indicator'

export type AudioIndicatorProps = {
  audioTrack?: LocalAudioTrack | RemoteAudioTrack | null
} & React.HTMLAttributes<HTMLSpanElement>

const audioIndicatorStyles = css({
  'pointer-events': 'none',
  display: 'flex',
})

export const AudioIndicator = ({
  className,
  audioTrack,
  ...props
}: AudioIndicatorProps) => {
  const icon = useAudioIndicator(audioTrack)

  return (
    <span
      className={cn(
        'topic__audio__indicator',
        audioIndicatorStyles(),
        className,
      )}
      {...props}
    >
      {icon}
    </span>
  )
}
